module.exports = "<app-password-confirm (formSubmitted)=\"onSubmit($event)\"></app-password-confirm>"